<template>
  <div
    class="layout"
    :class="[computedCharacterColorClass]"
  >
    <!-- 梵字・家紋 + 俗名 -->
    <div
      class="main"
      :class="{
        adjust: isSymbolAvailable,
      }"
    >
      <!-- 梵字・家紋 -->
      <div>
        <div
          v-if="isSymbolAvailable"
          class="symbol flex center"
        >
          <div class="box">
            <ImageResolver
              :src="computedSymbolSrc"
              class="character"
            />
          </div>
        </div>
      </div>

      <!-- 俗名 -->
      <div class="secularNames">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`secularName-${column.order}`"
          class="secularName flex center column"
        >
          <!-- 俗名 -->
          <TabletCharacterImage
            v-for="(character, index) in column.secularName"
            :key="`character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />

          <!-- 位表記 -->
          <TabletCharacterImage
            v-for="(character, index) in underCharacters"
            :key="`under-character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...underCharactersPayload,
              characterIndex: index,
              columnIndex: null,
              ...$event,
            })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.front,
    TabletPreviewMixin.character,
  ],
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
    // 梵字・家紋 + 戒名 + 位表記
    // の文字列の長さから要素一つあたりのサイズを算出
    computedCharacterSize () {
      const {
        isSymbolAvailable,
        columns,
        underCharacters,
      } = this;

      const defaultSize = 45;
      const maxHeight = !isSymbolAvailable ? 400 : 320 - 15;

      const characterLength = columns[0].secularName.length + underCharacters.length;
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    width: 50px;
    position: absolute;
    top: 0;
    left: -50px;
    box-sizing: border-box;
    overflow-x: visible;
    z-index: 1;

    &.adjust {
      padding-bottom: 15px; // (80 - 50) / 2
    }

    @include symbol(100px);  // (150 + 50) / 2

    .secularNames {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .secularName {
        height: 100%;
        transform: translateX(100px);

        @include character(45px);
      }
    }
  }
}
</style>
